import styled from 'styled-components';
import { color } from 'styles/colors';

export const container: any = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const optionsList: any = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  max-height: 150px;
  min-height: 150px;
  overflow: auto;
  background-color: ${color.interface.white};
  border-radius: 5px;
  border: 1px solid ${color.interface.lightGray2};
  padding: 5px;
  transform: translateY(105%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const noItens = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > p {
    font-size: 1rem;
    color: ${color.interface.darkgray};
  }
`;

export const loading = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > p {
    font-size: 1rem;
    color: ${color.interface.darkgray};
    animation: shine alternate-reverse ease 1s infinite;

    @keyframes shine {
      from {
        opacity: 0.2;
      }
      to {
        opacity: 1;
      }
    }
  }
`;

export const listOptions = styled.div`
  width: 100%;
  height: 150px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: flex-start;

  > button {
    all: unset;
    cursor: pointer;
    width: 100%;
    transition: all ease 0.5s;
    :hover {
      background-color: ${color.interface.lightGray2};
    }

    > p {
      width: 100%;
      text-align: left;
      font-size: 0.9rem;
    }
  }
`;
